import React, { useEffect, useState } from 'react';

// components
import EventPreviewDialogue from './EventPreviewDialogue';
import ThriveCheckBox from '../global/Checkbox';

// hooks
import useEventColour from  '@/components/hooks/useEventColour';

// utils and services
import { multiDayBuilder } from  '@/helpers/Planner';

//interfaces
import { plannerEvent } from  '@/interfaces/planner';
import { ToastData } from  '@/interfaces/LockerDetails';



interface DayMultiProps {
    date:Date,
    events:plannerEvent[],
    index: number,  
    setToast:(toastData:ToastData) => void,
    selectedEvents: number[],
    setSelectedEvents: (id:number) => void,
    hoverTargetId: number,
    setHoverTargetId: (id:number) => void
}

const DayMulti = ({date, events, index, setToast, selectedEvents, setSelectedEvents, hoverTargetId, setHoverTargetId}: DayMultiProps) => {

    const [days, setDays] = useState<plannerEvent[]>([])
    const [isToday, setIsToday] = useState<boolean>(false)
    const [showPreviewDialogue, setShowPreviewDialogue]= useState<boolean[]>([])

    const { cellStyle } = useEventColour()

    function startedLastWeek(event: plannerEvent) {
        return event.id !== 0 && index === 0
    }

    function endsNextWeek(event) {
        return event.id !== 0 && index === 6
    }

    useEffect(() => {

        const spanDays = multiDayBuilder(events, date)

        setDays(spanDays)

    }, [events, date])

    useEffect(() => {

        // Hightlight if its today
        const today = new Date();

        if (today.getFullYear() === date.getFullYear() 
            && today.getMonth() === date.getMonth() 
            && today.getDate() === date.getDate())
        {
            setIsToday(true)
        }
        else{
            setIsToday(false)
        }

    },[date])

    useEffect(() => {
        if(!showPreviewDialogue.some(el => el)) {
            setShowPreviewDialogue(events.map(() => false))
        }
    }, [events])

    function getAlignment() {
        switch(date.getDay()){
            case 0:
                return 'right-align';
            case 6: 
                return 'center-align';
            default:
                return 'left-align'
        }
    }

    function showCheckbox(evt: plannerEvent) {
        if(endsNextWeek(evt) || evt.occurrence.span === 'join-left') {
            return hoverTargetId === evt.id || !!selectedEvents.length
        }   
        return false;
    }

    function isLastDay(evt) {
        return endsNextWeek(evt) || evt.occurrence.span === 'join-left'
    }

    function showTitle(evt: plannerEvent) {
        return evt.occurrence.firstDay || startedLastWeek(evt)
    }

    return (
        <li className={`one-day ${isToday ? 'today':''} ${[0, 6].includes(date.getDay()) ? 'weekend' : ''}` }>
            

            {days.map((evt, i) => {
                const uniqueKey = `${i}-${evt.id}`
                return (
                    evt.occurrence.span !== 'blank' 
                    ?
                    <div
                        key={uniqueKey}
                        className={`event ${evt.occurrence.span} multi-span-title ${evt.isCancelled ?  'cancelled' : ''}`}
                        style={!evt.isCancelled ? cellStyle : {}}
                        onClick={()=> {setShowPreviewDialogue(showPreviewDialogue.map((ev, idx) => idx === i))}}
                        onFocus={() => {
                            if(!showPreviewDialogue[i]){
                                setShowPreviewDialogue(showPreviewDialogue.map(() => false))
                            }
                        }}
                        onMouseEnter={() => setHoverTargetId(evt.id)}
                        onMouseLeave={() => setHoverTargetId(0)}
                    >
                        { showTitle(evt) && <>
                            <h3 className={isLastDay(evt) && evt.awaitingApprovalCount > 0 ? 'is-last-day' : ''}>{evt.isCancelled ?  'Cancelled: ' : ''} {evt.title}</h3>
                            {/* hidden screen reader only button */}
                            <button
                                aria-label={`${evt.title} view details`}
                                className={'sr-only'}
                                onClick={()=> {setShowPreviewDialogue(showPreviewDialogue.map((ev, idx) => idx === i))}}
                                onFocus={() => {
                                    if(!showPreviewDialogue[i]){
                                        setShowPreviewDialogue(showPreviewDialogue.map(() => false))
                                    }
                                }}
                            />
                        </>}
                        {isLastDay(evt) &&
                            <div className='last-day-wrapper'>
                                {showCheckbox(evt)  && <div className='multi-day-checkbox-wrapper' style={{position:'absolute', right:'5px'}}>
                                    <ThriveCheckBox id={`select-${evt.title}-${evt.id}`} value={selectedEvents.includes(evt.id)} change={() => setSelectedEvents(evt.id)} name={`add ${evt.title} to download report`}/>
                                </div>} 
                                {evt.awaitingApprovalCount > 0  &&
                                    <span  className={`awaiting-approval-text ${showCheckbox(evt) ? 'checkbox-visible': ''}`}>
                                        {`${evt.awaitingApprovalCount} Awaiting Approval`}
                                    </span>
                                }
                            </div>
                        }
                        {showPreviewDialogue[i] && 
                            <EventPreviewDialogue
                                onClose={() => setShowPreviewDialogue(events.map(() => false))} 
                                evtId={evt.id}
                                alignment={getAlignment()}
                                setToast={setToast}
                            />
                        }
                        
                    </div>
                    : <div key={uniqueKey} className={`event ${evt.occurrence.span} multi-span-title ${evt.isCancelled ?  'cancelled' : ''}`} />
                )
            })}
        </li>
    );
};

export default DayMulti;